const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

// isContentEditable is also true inside nested editable regions, where the
// description editor puts focus.
export const isEditable = (element) => element?.isContentEditable || EDITABLE_TAGS.includes(element?.tagName);

export const hasModifier = (event) => event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;

// Our own dialogs, plus Vuetify overlays such as an open select menu. Tooltips
// are overlays too, but only hovering one must not disable the shortcuts.
export const isDialogOpen = () => Boolean(
  document.querySelector('.modal--active, .v-overlay--active:not(.v-tooltip)'),
);
